














import VueOptions from '@utils/VueOptions'
import ShoppingCartDiscountCard from '@ui/cards/ShoppingCartDiscountCard'

settings =
  name: 'ShoppingCartDiscountItems'

  vue:
    props: ['lineItems', 'wizard', 'options']
    components: { ShoppingCartDiscountCard }

export default VueOptions.vue settings
